import { DismissIcon, StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';
import type { Dispatch } from '@swf/core/store';
import { Pagination } from '@swf/poker';

import { ModalRoute } from '../../types';

import { TXTCLI_Next } from './OnboardStep.messages.json';
import styles from './OnboardStep.scss';

const OnboardStep: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { activeStep, handleClose, handleNext, steps } = useOnboardingContext();

  return (
    <div className={styles.container}>
      <div className={styles.header}>{steps[activeStep].heading}</div>
      <div className={styles.context}>{steps[activeStep].context as React.ReactNode}</div>
      <div className={styles.pagination}>
        <Pagination pagesCount={steps?.length} currentPageIndex={activeStep} />
      </div>
      <StarsButton
        className={styles.button}
        variant="secondary"
        onClick={() =>
          handleNext?.(() => {
            handleClose?.();
            modal.enqueue({ path: ModalRoute.OnboardingTourEnd });
          })
        }
        translation={TXTCLI_Next}
      />
      <StarsButton
        variant="text"
        size="extra-large"
        className={styles.close}
        icon={<DismissIcon />}
        onClick={() => handleClose?.()}
      />
    </div>
  );
};

export default OnboardStep;
